const enUS = {
  required: {
    firstName: 'Nombre es requerido',
    lastName: 'Apellido es requerido',
    email: 'Email es requiredo',
  },
};

export default enUS;
